module.exports = __webpack_public_path__ + "img/logo_entaneer.45b088bd.png";